// extracted by mini-css-extract-plugin
export default {"container":"Invoices_container__LAoKE","switchContainter":"Invoices_switchContainter__ZonkS"};